// extracted by mini-css-extract-plugin
module.exports = {"showMore":"show-more_showMore__xDo2x","showMoreWithIcon":"show-more_showMoreWithIcon__SVm6T"};